<div class='devo-pipeline-page'>

	<toolbar icon='Configuration'>

		<droplist [items]='[]' [popupConfig]='popupConfig' [navigation]='true'>
		</droplist>

		<!-- 
		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Monkey", iconClass: "fa-monkey", iconStyle:"fa-regular", hideText: "lt-md" }'></icon-text>
		</button>

		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Pizza", iconClass: "fa-pizza-slice", iconStyle:"fa-regular", hideText: "lt-lg" }'></icon-text>
		</button> -->

	</toolbar>

	<page-tabs [tabNames]='["Pipeline", "Tab1", "Tab2"]' [pageService]='pageService' (layoutChange)='onLayoutChange($event)'>

		<ng-template pageTab1>
			<devo-pipeline-views-part></devo-pipeline-views-part>
		</ng-template>

		<ng-template pageTab2>
			<devo-pipeline-tab-1-part></devo-pipeline-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<devo-pipeline-tab-2-part></devo-pipeline-tab-2-part>
		</ng-template>
	</page-tabs>

</div>